module.exports = __webpack_public_path__ + "static/img/banner-sumpah-pemuda.bbdf23b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/banner-sumpah-pemuda.png
// module id = E/8X
// module chunks = 1